export default function Hero() {
  const handleReservationClick = () => {
    const reservationSection = document.getElementById('reservation-section');
    if (reservationSection) {
      reservationSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 그라데이션 오버레이 */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 via-transparent to-cyan-500/20"></div>
      
      {/* 배경 이모지 애니메이션 */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        <span className="absolute top-20 left-10 text-4xl opacity-20 animate-[float_6s_ease-in-out_infinite]">🎉</span>
        <span className="absolute top-40 right-20 text-3xl opacity-15 animate-[float_8s_ease-in-out_infinite_1s]">✨</span>
        <span className="absolute top-60 left-1/4 text-5xl opacity-25 animate-[float_7s_ease-in-out_infinite_2s]">🌟</span>
        <span className="absolute top-32 right-1/3 text-3xl opacity-20 animate-[float_9s_ease-in-out_infinite_0.5s]">💫</span>
        <span className="absolute top-80 left-1/3 text-4xl opacity-15 animate-[float_6.5s_ease-in-out_infinite_1.5s]">🎊</span>
        <span className="absolute top-96 right-1/4 text-3xl opacity-20 animate-[float_8.5s_ease-in-out_infinite_2.5s]">⭐</span>
        <span className="absolute top-1/3 left-16 text-4xl opacity-25 animate-[float_7.5s_ease-in-out_infinite_3s]">🎈</span>
        <span className="absolute top-1/2 right-16 text-3xl opacity-15 animate-[float_6s_ease-in-out_infinite_1s]">💎</span>
        <span className="absolute top-2/3 left-1/5 text-4xl opacity-20 animate-[float_8s_ease-in-out_infinite_2s]">🔥</span>
        <span className="absolute top-3/4 right-1/5 text-3xl opacity-25 animate-[float_7s_ease-in-out_infinite_0.5s]">💖</span>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full pt-20">
        <div className="mb-8">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-extrabold tracking-tight mb-6 flex items-center justify-center gap-4">
            <span className="inline-block animate-bounce">✨</span>
            <span className="relative inline-block text-white">
              <span className="relative z-10 drop-shadow-[0_0_15px_rgba(168,85,247,0.8)]">예약 시스템</span>
              <span className="absolute inset-0 bg-gradient-to-r from-purple-500 via-pink-500 to-amber-500 blur-xl opacity-60 animate-[gradient_3s_ease_infinite] bg-[length:200%_auto] -z-0"></span>
              <span className="absolute inset-0 bg-gradient-to-r from-blue-500 via-cyan-500 to-purple-500 blur-2xl opacity-40 animate-[gradient_4s_ease_infinite_0.5s] bg-[length:200%_auto] -z-0"></span>
            </span>
            <span className="inline-block animate-pulse">🎉</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-12 leading-relaxed font-semibold">
            원하는 매장과 시간을 선택하고 빠르게 예약하세요
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-12">
          <button 
            onClick={handleReservationClick}
            className="relative inline-flex items-center justify-center px-10 py-4 rounded-full text-lg font-extrabold transition-all duration-300 shadow-lg hover:shadow-2xl whitespace-nowrap cursor-pointer bg-gradient-to-r from-purple-600 via-blue-500 to-cyan-500 text-white hover:scale-105"
          >
            지금 예약하기
          </button>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/70"></i>
      </div>
    </section>
  );
}
